import React from 'react';
import OverviewCard from '../../../../../components/OverviewCard';
import { FiShare2, FiTrendingUp, FiFilter, FiBookOpen, FiLayers, FiUsers } from 'react-icons/fi';
import { useQuery } from 'react-query';
import { dashboardApi } from '../../../../../api/dashboard';

const DashboardSummary = () => {
  const { data: stats, isLoading } = useQuery(
    ['admin-dashboard-stats'],
    () => dashboardApi.getDashboardStats(),
    {
      cacheTime: 300000,
      staleTime: 300000,
      refetchOnWindowFocus: false,
      select: (data) => data?.data,
    }
  );

  return (
    <header className='grid pt-3 grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4'>
      <OverviewCard
        title={'Total Learning Paths'}
        total={isLoading ? '...' : stats?.totalLearningPaths ?? '—'}
        icon={<FiShare2 size={20} />}
        headerTextSize='text-2xl'
      />
      <OverviewCard
        title={'Active Paths'}
        total={isLoading ? '...' : stats?.activePaths ?? '—'}
        icon={<FiTrendingUp size={20} />}
        headerTextSize='text-2xl'
      />
      <OverviewCard
        title={'Inactive Paths'}
        total={isLoading ? '...' : stats?.inactivePaths ?? '—'}
        icon={<FiFilter size={20} />}
        headerTextSize='text-2xl'
      />
      <OverviewCard
        title={'Total Courses'}
        total={isLoading ? '...' : stats?.totalCourses ?? '—'}
        icon={<FiBookOpen size={20} />}
        headerTextSize='text-2xl'
      />
      <OverviewCard
        title={'Total Modules'}
        total={isLoading ? '...' : stats?.totalModules ?? '—'}
        icon={<FiLayers size={20} />}
        headerTextSize='text-2xl'
      />
      <OverviewCard
        title={'Total Learners'}
        total={isLoading ? '...' : stats?.totalLearners ?? '—'}
        icon={<FiUsers size={20} />}
        headerTextSize='text-2xl'
      />
    </header>
  );
};

export default DashboardSummary;
